import type { ProjectGraphFinding } from '@avisoma/shared';
import { Badge } from '../../catalyst/badge';
import { severityColor } from './findings';

/** The supervisor findings about the selected node: severity, check and reason, and the status once acted on. */
export function NodeFindings({ findings }: { findings: ProjectGraphFinding[] }) {
  if (findings.length === 0) return null;
  return (
    <div className="flex flex-col gap-2">
      <div className="mt-2 font-medium">Findings</div>
      <ul className="flex flex-col gap-2">
        {findings.map((finding) => (
          <li key={finding.id} className="flex flex-col gap-0.5">
            <div className="flex flex-wrap items-center gap-2">
              <Badge color={severityColor(finding.severity, finding.status)}>{finding.severity}</Badge>
              <span className="break-words">{finding.kind}</span>
              {finding.status !== 'proposed' && (
                <span className="text-zinc-500 dark:text-zinc-400">{finding.status}</span>
              )}
            </div>
            <p className="text-sm break-words text-zinc-600 dark:text-zinc-300">{finding.reason}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
